import { useGetDosagesQuery } from "src/api/services/dosagesApi";
import { MedicationForm } from "src/api/types";
import { useMemo } from "react";

export const useSelectableDosages = (
  productId: number,
  form?: MedicationForm,
) => {
  const { data } = useGetDosagesQuery({
    productId,
    params: { form },
  });

  const dosages = useMemo(() => {
    if (data == null) return [];

    return data.map((d) => `${d.amount} ${d.unit}`);
  }, [data]);

  return dosages;
};
